export const paymentMethodReport = {
	titleBar: "Método de pago por Bar",
	titleEmployee: "Método de pago por Empleado",
	info:
		"Los valores de este informe pueden haber sido estimados y por lo tanto puede haber pequeñas diferencias",
	sheet: {
		titleBar: "Método de pago por Bar",
		filenameBar: "metodo-pago-bar",
		titleEmployee: "Método de pago por Empleado",
		filenameEmployee: "metodo-pago-empleado",
	},
	columns: {
		App: "App",
		Cash: "Efectivo",
		DebitCard: "Débito",
		CreditCard: "Crédito",
		Voucher: "Voucher",
		ZigPosDebit: "Débito Zig",
		ZigPosCredit: "Crédito Zig",
		PostEvent: "Post Evento",
		Dashboard: "Panel",
		Anticipated: "Anticipado",
		DeliveryOnline: "Delivery",
		Consumption: "Consumo",
		Ame: "Ame",
		Rappi: "Rappi",
		Uber: "Uber",
		Ifood: "Ifood",
		Bonus: "Bono",
		Pix: "Pix",
		Opened: "Abierto",
		Other: "Otros",
		ZigPosCreditInInstallments: "Crédito Zig en Cuotas",
		IntegratedFoodVoucher: "Vale de Alimentación",
		name: "Nombre",
		total: "Total",
	},
};
